import type { ApolloError } from '@apollo/client';
import type { TFunction } from 'i18next';

/**
 * 移入 / 移出接口的业务错误文案：后端 BusinessException 不会被全局 errorLink 提示（只有少数 key 例外），
 * 由调用方按 `extensions.messageKey` + `details` 渲染；取不到时回落通用失败文案。
 */
export const moveErrorMessage = (error: unknown, t: TFunction | ((key: string, opts?: Record<string, unknown>) => string)): string => {
    const extensions = (error as ApolloError | undefined)?.graphQLErrors?.[0]?.extensions;
    const messageKey = extensions?.messageKey as string | undefined;
    if (messageKey) {
        const details = (extensions?.details as Record<string, unknown> | undefined) ?? undefined;
        return String(details ? t(messageKey, details) : t(messageKey));
    }
    return String(t('wms.sortingBatch.common.requestFailed'));
};
